module.exports = __webpack_public_path__ + "static/img/icon4.4ec38cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon4.png
// module id = Hh7f
// module chunks = 1